import { SxProps, Theme } from '@mui/material';

export const adminCard: SxProps<Theme> = {
  bgcolor: '#fff',
  border: '1px solid #eceef1',
  borderRadius: '12px',
  boxShadow: 'none',
  transition: 'border-color 0.15s ease',
  '&:hover': { borderColor: '#d1d5db' },
};

export const adminTableContainer: SxProps<Theme> = {
  bgcolor: '#fff',
  border: '1px solid #eceef1',
  borderRadius: '12px',
  boxShadow: 'none',
  overflow: 'hidden',
};

export const adminTableHead: SxProps<Theme> = {
  bgcolor: '#f8f9fb',
  '& .MuiTableCell-head': {
    color: '#6b7280',
    fontWeight: 600,
    fontSize: '0.72rem',
    textTransform: 'uppercase' as const,
    letterSpacing: '0.04em',
    borderBottom: '1px solid #eceef1',
    py: 1.25,
  },
};

export const adminTableRow: SxProps<Theme> = {
  transition: 'background 0.1s ease',
  '&:hover': { bgcolor: '#f8f9fb' },
  '& .MuiTableCell-body': {
    fontSize: '0.82rem',
    color: '#374151',
    borderBottom: '1px solid #f3f4f6',
    py: 1.25,
  },
};

export const adminPageTitle: SxProps<Theme> = {
  fontSize: '1.15rem',
  fontWeight: 650,
  color: '#111827',
  letterSpacing: '-0.02em',
};

export const adminPageSubtitle: SxProps<Theme> = {
  fontSize: '0.8rem',
  color: '#9ca3af',
  mt: 0.25,
};

export const adminSectionTitle: SxProps<Theme> = {
  fontSize: '0.82rem',
  fontWeight: 600,
  color: '#111827',
  letterSpacing: '-0.01em',
};

export const adminRefreshButton: SxProps<Theme> = {
  textTransform: 'none',
  fontWeight: 500,
  fontSize: '0.78rem',
  color: '#6b7280',
  borderColor: '#e5e7eb',
  borderRadius: '10px',
  px: 2,
  '&:hover': { bgcolor: '#f3f4f6', borderColor: '#d1d5db', color: '#374151' },
};

export const adminPrimaryButton: SxProps<Theme> = {
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '0.8rem',
  bgcolor: '#111827',
  color: '#fff',
  borderRadius: '10px',
  px: 2.5,
  py: 0.8,
  boxShadow: 'none',
  '&:hover': { bgcolor: '#1f2937', boxShadow: 'none' },
  '&:disabled': { bgcolor: '#e5e7eb', color: '#9ca3af' },
};

export const adminSecondaryButton: SxProps<Theme> = {
  textTransform: 'none',
  fontWeight: 500,
  fontSize: '0.78rem',
  color: '#6b7280',
  borderRadius: '10px',
  px: 2,
  '&:hover': { bgcolor: '#f3f4f6', color: '#374151' },
};

export const adminInput: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    bgcolor: '#f8f9fb',
    fontSize: '0.85rem',
    transition: 'all 0.15s ease',
    '& fieldset': { borderColor: '#e5e7eb' },
    '&:hover': { bgcolor: '#f3f4f6', '& fieldset': { borderColor: '#d1d5db' } },
    '&.Mui-focused': { bgcolor: '#fff', '& fieldset': { borderColor: '#111827', borderWidth: '1.5px' } },
  },
  '& .MuiInputLabel-root': { fontSize: '0.8rem', color: '#6b7280' },
  '& .MuiInputLabel-root.Mui-focused': { color: '#111827' },
};

export const adminChip: SxProps<Theme> = {
  height: 22,
  fontSize: '0.7rem',
  fontWeight: 500,
  borderRadius: '6px',
  border: '1px solid #e5e7eb',
  bgcolor: '#f8f9fb',
  color: '#374151',
};

export const adminStatCard = (accent: string = '#f3f4f6'): SxProps<Theme> => ({
  bgcolor: '#fff',
  border: '1px solid #eceef1',
  borderRadius: '12px',
  boxShadow: 'none',
  p: 2,
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 3,
    bgcolor: accent,
    borderRadius: '12px 12px 0 0',
  },
});

export const adminDialog: SxProps<Theme> = {
  borderRadius: '16px',
  boxShadow: '0 24px 48px -12px rgba(0,0,0,0.18)',
  overflow: 'hidden',
};

export const adminDialogTitle: SxProps<Theme> = {
  fontSize: '1rem',
  fontWeight: 650,
  color: '#111827',
  letterSpacing: '-0.02em',
};

export const adminAlert: SxProps<Theme> = {
  borderRadius: '10px',
  fontSize: '0.8rem',
  '& .MuiAlert-icon': { fontSize: '1.1rem' },
};
